<template>
  <div class="go-in">
    <div
      class="introduction"
      :style="`height:${pageLoading ? '3rem' : 'auto'};`"
      v-loading="pageLoading"
    >
      <TitleTips
        :routerList="routerList"
        routeType="/newsDetail"
        title="新闻详情"
      />
      <!-- <div style="display:flex;flex-direction: column;align-items: center; ">
        <span style="color:#333;font-size:0.4rem;">公司党委组织参观红色教育基地主体党日活动</span>
          <div style="margin: 0.2rem 0rem; font-size: 0.12rem;color: #ccc;">
            <span><i class="el-icon-view" style="margin-right:0.05rem"></i>200</span>
            <span style="margin:1.4rem"><i class="el-icon-time" style="margin-right:0.05rem"></i>2017-1-12 12:12</span>
            <span><i class="el-icon-user" style="margin-right:0.05rem"></i>本站</span>
          </div>
        <span style="font-size:0.14rem;color: #686868;"  v-html="pageObj.txt"></span>
        <div style="width:100%;display:flex;justify-content:space-between; ">
          <el-button class="lastBtn" plain icon="el-icon-arrow-left">上一篇</el-button>
          <el-button class="nextBtn" plain>下一篇<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </div>
      </div> -->
      <!-- <div style="display:flex;flex-direction: column;align-items: center; ">
        <span style="color:#333;font-size:0.4rem;">{{currentNewsList[currentIndex].title}}</span>
          <div style="margin: 0.2rem 0rem; font-size: 0.12rem;color: #ccc;">
            <span><i class="el-icon-view" style="margin-right:0.05rem"></i>{{currentNewsList[currentIndex].liuliang}}</span>
            <span style="margin:1.4rem"><i class="el-icon-time" style="margin-right:0.05rem"></i>{{currentNewsList[currentIndex].createTime}}</span>
            <span><i class="el-icon-user" style="margin-right:0.05rem"></i>{{currentNewsList[currentIndex].userName}}</span>
          </div>
        <span style="font-size:0.14rem;color: #686868;"  v-html="currentNewsList[currentIndex].txt"></span>
        <div style="width:100%;display:flex;justify-content:space-between; ">
          <el-button :loading="stepLoading" @click="lastOne" class="lastBtn" plain icon="el-icon-arrow-left">上一篇</el-button>
          <el-button :loading="stepLoading" @click="nextOne"  class="nextBtn" plain>下一篇<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </div>
      </div> -->
      <div style="display: flex; flex-direction: column; align-items: center">
        <span style="color: #333; font-size: 0.4rem">{{
          detailPage.title
        }}</span>
        <div style="margin: 0.2rem 0rem; font-size: 0.12rem; color: #ccc">
          <span
            ><i class="el-icon-view" style="margin-right: 0.05rem"></i
            >{{ detailPage.count }}</span
          >
          <span style="margin: 1.4rem"
            ><i class="el-icon-time" style="margin-right: 0.05rem"></i
            >{{ detailPage.createTime }}</span
          >
          <span
            ><i class="el-icon-user" style="margin-right: 0.05rem"></i
            >{{ detailPage.userName }}</span
          >
        </div>
        <span
          style="font-size: 0.14rem; color: #686868"
          v-html="detailPage.txt"
        ></span>
        <div style="width: 100%; display: flex; justify-content: space-between">
          <el-button
            :loading="stepLoading"
            @click="lastOne()"
            v-if="preId"
            class="lastBtn"
            plain
            icon="el-icon-arrow-left"
            >上一篇</el-button
          >
          <el-button
            :loading="stepLoading"
            @click="nextOne()"
            v-if="nextId"
            class="nextBtn"
            plain
            >下一篇<i class="el-icon-arrow-right el-icon--right"></i
          ></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from '../components/TitleTips.vue';
import merge from 'webpack-merge';
import http from '../utils/http';
export default {
  components: {
    TitleTips
  },
  name: 'companyNewsDetail',
  data() {
    return {
      imgUrlBanner: '',
      pageObj: {},
      routerList: [],
      currentPageNum: 0,
      currentPageSize: 0,
      // currentNewsList: [],
      currentNewsPage: {},
      currentIndex: 0,
      stepLoading: false,
      pageLoading: false,
      groupType: '',

      currenId: '',
      nextId: '',
      preId: '',
      detailPage: {}
    };
  },
  created() {
    // this.$route.fullpath
    // debugger
    this.currenId = this.$route.params.id;
    this.getDetailData(this.currenId);
    // this.recordQuest(this.currenId);
  },
  methods: {
    lastOne() {
      this.$router.replace({
        path: `/news/newsDetail/${this.preId}`
      });
    },
    nextOne() {
      this.$router.replace({
        path: `/news/newsDetail/${this.nextId}`
      });
    },
    // 记录请求
    // recordQuest(val) {
    //   http.post("/reception/news/updateCount", { id:val }).then((res) => {
    //     // this.currentNewsList[this.currentIndex]["flag"] = true;
    //   });
    // },
    // 详情数据请求
    getDetailData(id) {
      this.pageLoading = true;
      http
        .post('/reception/news/queryPage', { id })
        .then(res => {
          this.preId = res.data.preId;
          this.nextId = res.data.nextId;
          // const str = res.data.txt;
          // const a = str.replace(
          //   /http:\/\/[^/]+\//g,
          //   'https://www.hongxing799.com/'
          // );
          // res.data.txt = a;
          this.detailPage = Object.assign({}, res.data);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    }
  },
  mounted() {
    this.routerList = this.$route.matched;
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  .introduction {
    width: 100%;
    box-sizing: border-box;
    padding: 0rem 1rem 0.5rem 1rem;
    .lastBtn {
      width: 0.8rem;
      height: 0.3rem;
    }
    .nextBtn {
      width: 0.8rem;
      height: 0.3rem;
    }
  }
}
</style>
